import React, { useState } from 'react';
import { classNames } from 'react-extras';
import { PrismicLink } from 'components/PrismicLink';
import { colSize_t, GridCol } from 'components/UI/Grid';
import { FooterItem } from '..';

type MainFooterColumnProps = {
    title: string;
    items?: FooterItem[];
    shrink?: boolean;
    colNum?: colSize_t;
};

type MainFooterColumnState = {
    expanded: boolean;
};

const MainFooterColumn: React.FunctionComponent<MainFooterColumnProps> = props => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => setIsExpanded(!isExpanded);

    return (
        <GridCol
            colSize={props.colNum}
            offsetSize={`0`}
            mobileColSize={'12'}
            className={classNames('MainFooter-column', {
                'MainFooter-column--expanded': isExpanded,
            })}
            data-testid="column"
        >
            <div onClick={toggleExpanded} className="MainFooter-columnTitle">
                {props.title}
                <span className="Icon u-clickable u-hidden-lg-up">
                    {/* TODO Remove this once we have actual icons */}
                    {/* {isExpanded ? '⌃' : '⌄'} */}⌃
                </span>
            </div>
            <div className="MainFooter-columnContent">
                {props.items &&
                    props.items.map((item: FooterItem, index) => (
                        <PrismicLink
                            key={index}
                            label={item.label}
                            link={item.link}
                            className="MainFooter-link MainFooter-column-item"
                        />
                    ))}
                {props.children}
            </div>
        </GridCol>
    );
};

export { MainFooterColumn, MainFooterColumnProps, MainFooterColumnState };
